import type { CardData } from '../../../types'
import { MethodDetail } from '../MethodDetail'

export function MethodView({ mobileCards, path, onMobileBack, onMobileMethodNavigate }: CardData) {
  const methodKey = path[2]
  const currentIndex = mobileCards?.findIndex((c) => c.id === methodKey) ?? -1
  const currentCard = mobileCards?.[currentIndex]

  if (!currentCard) return null

  return (
    <MethodDetail
      methodName={currentCard.name}
      badge={currentCard.badge}
      content={currentCard.content}
      currentIndex={currentIndex}
      totalCount={mobileCards?.length ?? 0}
      onBack={onMobileBack}
      onPrevious={
        currentIndex > 0
          ? () => {
              const previousCard = mobileCards?.[currentIndex - 1]
              if (previousCard) onMobileMethodNavigate(previousCard.id)
            }
          : undefined
      }
      onNext={
        currentIndex < (mobileCards?.length ?? 0) - 1
          ? () => {
              const nextCard = mobileCards?.[currentIndex + 1]
              if (nextCard) onMobileMethodNavigate(nextCard.id)
            }
          : undefined
      }
    />
  )
}
